function Latvia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1495)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C8.60752 0 2.38715 5.01381 0.551147 11.8261H31.4488C29.6128 5.01381 23.3924 0 16 0Z" fill="#A2001D"/>
  <path d="M16 31.9999C23.3924 31.9999 29.6128 26.9861 31.4488 20.1738H0.551147C2.38715 26.986 8.60752 31.9999 16 31.9999Z" fill="#A2001D"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Latvia;
